import { Alert } from '@consumidor-positivo/aurora';

export const PixPaymentConfirmationAlert = () => {
  return (
    <Alert
      showIcon={false}
      status="info"
      type={2}
      title={{
        content: <b>Confirmação de Pagamento</b>,
        weight: 'bold',
      }}
    >
      Para pagamentos realizados via Pix, caso o parceiro identifique qualquer inconsistência na efetivação do acordo realizado em nossa plataforma, o
      valor pago será devolvido integralmente à conta de origem.
      <br />
      <br />
      Confirmado o recebimento do acordo pelo parceiro, o pagamento será considerado válido, a parcela correspondente será quitada e o valor não será
      reembolsado. As demais parcelas continuarão sendo cobradas normalmente, quando aplicável.
    </Alert>
  );
};
